import { Component} from '@angular/core';

// 1. Interface for Fun Facts
export interface FactItem {
  value: string;
  label: string;
  delay: string;
}

@Component({
  standalone: false,
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.css'
})
export class ErrorComponent {
  // Fun Facts Data Array
  facts: FactItem[] = [
    {
      value: '99',
      label: 'Success in getting happy customer',
      delay: '.1s'
    },
    {
      value: '25',
      label: 'Thousands of successful business',
      delay: '.3s'
    },
    {
      value: '120',
      label: 'Total clients who love HighTech',
      delay: '.5s'
    },
    {
      value: '5',
      label: 'Stars reviews given by satisfied clients',
      delay: '.7s'
    }
  ];

  // Lifecycle Hooks
  ngOnInit(): void {
    // Initialization code (if any)
  }

  ngOnDestroy(): void {
    // Cleanup code (if any)
  }
}
